import { StorageType } from './enum/type.enum';

export class StorageUtil {
  public static getDataFromStorage(key: string, type: StorageType) {
    let _storage =
      type === StorageType.LOCAL_STORAGE
        ? window.localStorage
        : window.sessionStorage;

    return _storage.getItem(key);
  }
}
